
export default function Testimonials() {
  return (
    <section className="w-full bg-[#F8F8F8] py-16 md:py-24 px-4 md:px-8 lg:px-16">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-12 md:mb-16">
          <h2
            className="text-[32px] md:text-[48px] font-bold text-[#1A1A1A] mb-4 md:mb-6"
            style={{ fontFamily: 'Montserrat, sans-serif' }}
          >
            What Our Customers Say
          </h2>
          <p
            className="text-[16px] md:text-[18px] text-[#666666]"
            style={{ fontFamily: 'Montserrat, sans-serif' }}
          >
            Trusted by professionals and DIYers nationwide
          </p>
        </div>

        <div className="bg-white rounded-lg shadow-xl overflow-hidden">
          <div className="flex flex-col md:flex-row">
            {/* Left side - Quote */}
            <div className="w-full md:w-2/3 p-8 md:p-12">
              <div className="mb-6">
                <i className="ri-double-quotes-l text-[48px] md:text-[64px] text-[#F2C612]"></i>
              </div>
              <p
                className="text-[18px] md:text-[22px] text-[#1A1A1A] leading-relaxed mb-6 md:mb-8"
                style={{ fontFamily: 'Montserrat, sans-serif', fontWeight: 500 }}
              >
                We've been using BEST Contractor Grade products for over 10 years. The consistency and reliability are unmatched. Our clients trust us because we trust BEST.
              </p>
              <div className="flex items-center gap-4">
                <div className="w-14 h-14 md:w-16 md:h-16 bg-[#1A1A1A] rounded-full flex items-center justify-center">
                  <span
                    className="text-[#F2C612] text-[20px] md:text-[24px] font-bold"
                    style={{ fontFamily: 'Montserrat, sans-serif' }}
                  >
                    MJ
                  </span>
                </div>
                <div>
                  <div
                    className="text-[16px] md:text-[18px] font-bold text-[#1A1A1A]"
                    style={{ fontFamily: 'Montserrat, sans-serif' }}
                  >
                    Michael Johnson
                  </div>
                  <div
                    className="text-[14px] md:text-[15px] text-[#666666]"
                    style={{ fontFamily: 'Montserrat, sans-serif' }}
                  >
                    Master Tiler, Johnson Tiling Co.
                  </div>
                </div>
              </div>
            </div>

            {/* Right side - Rating */}
            <div className="w-full md:w-1/3 bg-[#1A1A1A] p-8 md:p-12 flex flex-col justify-center items-center text-center">
              <div className="mb-4">
                <div className="flex gap-2 justify-center mb-3">
                  {[...Array(5)].map((_, i) => (
                    <i key={i} className="ri-star-fill text-[#F2C612] text-[24px] md:text-[28px]"></i>
                  ))}
                </div>
                <div
                  className="text-[42px] md:text-[56px] font-black text-white"
                  style={{ fontFamily: 'Montserrat, sans-serif' }}
                >
                  4.9/5
                </div>
              </div>
              <p
                className="text-[14px] md:text-[15px] text-[#DDDDDD]"
                style={{ fontFamily: 'Montserrat, sans-serif' }}
              >
                Based on 2,400+ reviews
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}